




















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Typed extends Vue {
  @Prop() public options
}
